import { apiDelete, apiGet, apiPost } from './client';

export interface SourceConnection {
  id: string;
  name: string;
  source_type: string;
  config: Record<string, unknown>;
  delta_cursor: string | null;
  last_synced_at: string | null;
  created_at: string | null;
}

export interface AclCoverage {
  total_entries: number;
  matched_users: number;
  unmatched_users: number;
  unmatched_user_emails: string[];
  group_entries: number;
  open_access_entries: number;
}

export interface CreateSourceConnectionRequest {
  name: string;
  source_type: string;
  config: Record<string, unknown>;
}

export async function getSourceConnections(): Promise<SourceConnection[]> {
  const res = await apiGet<{ data: SourceConnection[] }>('/source-connections');
  return res.data;
}

export function createSourceConnection(
  data: CreateSourceConnectionRequest,
): Promise<SourceConnection> {
  return apiPost<SourceConnection>('/source-connections', data);
}

export function deleteSourceConnection(id: string): Promise<void> {
  return apiDelete(`/source-connections/${id}`);
}

export function testSourceConnection(
  id: string,
): Promise<{ ok: boolean; message: string }> {
  return apiPost<{ ok: boolean; message: string }>(`/source-connections/${id}/test`);
}

export function getAclCoverage(id: string): Promise<AclCoverage> {
  return apiGet<AclCoverage>(`/source-connections/${id}/acl-coverage`);
}
